// packages import
import AddIcon from "@mui/icons-material/Add"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import FileUploadIcon from "@mui/icons-material/FileUpload"
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material"
import { FC, useContext } from "react"
import { Link, useNavigate } from 'react-router-dom'
// others
import { AppContext } from '../../context/AppContext';
import { ActionType } from '../../context/AppContextReducer';
import { ContentHeadProps } from '../../interfaceTypes';
import { CardHeader } from '../../theme/styleComponents';

export const ContentHead: FC<ContentHeadProps> = ({ title, buttonText, link, csvButton, isCase, subtitle, backButton, customButton, customOnClick, sx }): JSX.Element => {
  const { isOpen, dispatch, isCsvUpload } = useContext(AppContext)
  const navigate = useNavigate()

  const handleModalOpen = () => {
    customOnClick?.()
    return dispatch({ type: ActionType.SET_IS_OPEN, isOpen: !isOpen })
  }

  const handleCSVModalOpen = () => {
    dispatch({ type: ActionType.SET_IS_CSV_Upload, isCsvUpload: !isCsvUpload })
  }

  return (
    <CardHeader direction="row" sx={{ p: 2, ...sx }} flexWrap="wrap" gap="10px">
      <Box display="flex" alignItems="center" gap={2}>
        {backButton && (
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon color="primary" />
          </IconButton>
        )}

        <Typography variant="body1" fontSize="24px">
          {title}
        </Typography>

        {subtitle && (
          <Typography variant="body1" fontSize="16px" color="gray">
            {subtitle}
          </Typography>
        )}
      </Box>

      <Box display="flex" gap="10px" flexWrap="wrap">
        {customButton && customButton()}

        {buttonText ? (
          link ? (
            <Button color="primary" variant="contained" startIcon={<AddIcon />} component={Link} to={link} aria-label={buttonText}>
              {buttonText}
            </Button>
          ) : (
            <Button color="primary" variant="contained" startIcon={<AddIcon />} onClick={handleModalOpen} aria-label={buttonText}>
              {buttonText}
            </Button>
          )
        ) : null}

        {/* {csvButton && (
          <Tooltip title={isCase ? 'Upload case CSV' : 'Upload user CSV'} arrow placement="top">
            <Button color="primary" variant="outlined" onClick={handleCSVModalOpen}>
              <FileUploadIcon />
            </Button>
          </Tooltip>
        )} */}
      </Box>
    </CardHeader>
  );
}